import React from 'react'
import { isAndroidNative } from 'utils/platform'
import { FaceAndroidIcon, FaceIdRecognitionIcon } from '../../../Icon'
import NumpadInputButton from '../numpad-input-button'
import type { NumpadInputFaceIdButtonProps } from './types'

const NumpadInputFaceIdButton: React.FC<NumpadInputFaceIdButtonProps> = ({ handleKeychainPin }) => (
  <NumpadInputButton
    ariaLabel="Numpad TouchId"
    testId="numpad-touchid"
    icon={isAndroidNative() ? <FaceAndroidIcon /> : <FaceIdRecognitionIcon />}
    onClick={handleKeychainPin}
  />
)

export default NumpadInputFaceIdButton
